import PopupCreator from "../PopupCreator"
import MarkerCreator from "../MarkerCreator"
import ObjectsSupeclasterGroup from './ObjectsSupeclasterGroup'

class ObjectsSupeclasterLayerDrawer {
  vm = null
  _map = null
  _layers = null

  constructor (map, opts = {vm: null}) {
    this.vm = opts.vm
    this._map = map

    this.popupCreator = new PopupCreator(this.vm)
    this.markerCreator = new MarkerCreator(this.vm)
  }

  removeLayers () {
    for (let key in this._layers) {
      this._layers[key].remove()
    }
  }

  setLayersConfigAndDraw (layerConfig) {
    let layers = {}
    for (let name in layerConfig) {
      let layer = layerConfig[name]
      let groups = {}
      if (layer.groups) {
        for (let groupName in layer.groups) {
          if (layer.groups[groupName]) {
            let restApiOrder = layer.groups[groupName].restApiOrder
            groups[restApiOrder] = {
              layerConfig: layer,
              subLayerConfig: layer.groups[groupName],
              checkbox: groupName
            }
          }
        }
      }

      layers[name] = this.createLayer(name, layer, groups)
    }

    this._layers = layers
    return this._layers
  }

  createLayer (name, layer, groups) {
    return new ObjectsSupeclasterGroup(this._map, {
      layer,
      checkbox: name,
      groups
    }, {
      vm: this.vm,
      popupCreator: this.popupCreator,
      markerCreator: this.markerCreator,
    })
  }
}

export default ObjectsSupeclasterLayerDrawer
